<template lang="pug">
    div.reminderWrapper
        div

            // Button
            div.reminder.ml-2(@click="reminderAction" :class="{'notificationsOff' : notificationsOff}")
                v-icon.reminderIcon {{ reminderIcon }}
</template>

<script>
    import sessions from '~api/sessions';
    import Handler from '~services';
    import VueTypes from 'vue-types';
    import dayjs from 'dayjs';

    export default {
        props: {
            id: VueTypes.string.def(''),
            startedAt: VueTypes.string.def(''),
            hasReminder: VueTypes.bool.def(false)
        },
        data() {
            return {
                reminderAdded: false
            };
        },
        computed: {
            /**
             * Icon name
             */
            reminderIcon() {
                return this.hasReminder || this.reminderAdded
                    ? 'notifications_active'
                    : 'notifications_off';
            },

            notificationsOff() {
                return !(this.hasReminder || this.reminderAdded);
            },
            reminderDate() {
                return dayjs(this.startedAt)
                    .subtract(5, 'minute')
                    .format('D MMMM, h:mm a');
            },

            /**
             * Reminder button action
             */
            reminderAction() {
                return this.hasReminder || this.reminderAdded
                    ? this.removeReminder
                    : this.setReminder;
            }
        },
        methods: {
            /**
             * Set reminder
             * @returns {Promise<void>}
             */
            async setReminder() {
                const successMessage = 'Reminder added';
                const resp = await sessions.setReminderOnLive(this.id);

                this.reminderAdded = true;

                Handler.handleResponse(resp, successMessage);
            },

            /**
             * Remove reminder
             * @returns {Promise<void>}
             */
            async removeReminder() {
                const successMessage = 'Reminder removed';
                const resp = await sessions.removeReminderFromLive(this.id);

                this.reminderAdded = false;
                Handler.handleResponse(resp, successMessage);
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../assets/style/_variables.styl';

    .reminderWrapper
        position: absolute
        right: 12px
        top: 18px
        color: $theme.white
        z-index: 3
        text-shadow: 0 0 2px rgba(0, 0, 0, 0.4);

        > div
            display: flex
            align-items: center

    .reminderLabel
        font-size: 8px
        text-transform: uppercase

    .reminderDate
        font-weight: bold;
        font-size: 11px;

    .reminder
        width: 30px
        height: 30px
        border-radius: 30px
        background-color: $theme.action
        display: flex
        align-items: center
        justify-content: center
        cursor: pointer
        transition: transform .3s

        &:hover
            transform: scale(1.15)

    .reminderIcon
        color: $theme.white
        font-size: 22px

    .notificationsOff
        background-color: rgba(0, 0, 0, 0.5)
</style>
